interface WelcomeSectionProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

export function WelcomeSection({ 
  title = "", 
  subtitle = "", 
  description = ""
}: WelcomeSectionProps) {
  return (
    <>
      <header className="w-full font-semibold max-md:max-w-full sm:mt-14 mt-4" style={{ color: '#111827' }}>
        <h1 className="self-stretch w-full text-xl sm:text-2xl max-md:max-w-full" style={{ color: '#111827' }}>
          {title}
        </h1>
        <h2 className="self-stretch mt-1.5 w-full text-sm font-normal max-md:max-w-full" style={{ color: '#374151' }}>
          {subtitle}
        </h2>
      </header>
      <section className="flex flex-col justify-center w-full mt-4 sm:mt-5 text-sm font-normal max-md:max-w-full" style={{ color: '#374151' }}>
        <p className="flex-1 shrink gap-2.5 self-stretch w-full basis-0 max-md:max-w-full">
          {description}
        </p>
      </section>
    </>
  );
}
